import { TableRequest } from "./../data/dataContracts";
import { BaseEntity } from "./../baseEntity";
export class CompanyRequest extends BaseEntity {
}
export class CompanyResponse extends BaseEntity {
}
export class GetCompaniesRequest extends TableRequest {
}
